import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "./CustomvideoForm"; // Make sure this form can handle video input
import { LOADING, MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

// Fields specific to video
const fields = [
    { label: "Title", name: "title", placeholder: "Enter Title", required: true },
    { label: "Date", name: "date", type: "date", required: true },
    { label: "Time", name: "time", type: "time", required: true }, // New time field
    { label: "Iframe", name: "iframe", placeholder: "add video iframe", type: "iframe" },
  ];
  

const EditVideo = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const loadVideoData = async () => {
      if (!id) return;

      try {
        const response = await axios.get(`${API_URL}/video/getVideoById/${id}`);

        // Log response data to inspect structure
        console.log("API response data:", response.data);

        // Use response.data directly if data is not nested in a "data" field
        const videoData = response.data;

        if (videoData) {
          setInitialData({
            ...videoData,
            video: videoData.video, // Assuming video URL is stored here
          });
          setVideoPreview(videoData.video || ""); // Set the video preview URL
        } else {
          throw new Error("Video data not found");
        }
      } catch (error) {
        console.error("Error loading video data:", error);
        toast.error("Error loading video data");
      }
    };

    loadVideoData();
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      // If a new video file is uploaded, handle it appropriately
      if (formData.video instanceof File) {
        // If your formData is constructed properly to handle file uploads
        const formDataWithFile = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          formDataWithFile.append(key, value);
        });
        await axios.put(`${API_URL}/video/updateVideo/${id}`, formDataWithFile, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Update without new video file
        await axios.put(`${API_URL}/video/updateVideo/${id}`, formData);
      }
      toast.success("Video updated successfully", { autoClose: 1000 });
      navigate("/videos");
    } catch (error) {
      console.error("Error updating video:", error);
      toast.error("Error updating video", { autoClose: 1000 });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Video
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/videos")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Form
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          videoPreview={videoPreview} // For displaying video preview
        />
      ) : (
        <p>{LOADING}</p>
      )}

      
    </div>
  );
};

export default EditVideo;
